function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("path", {
  d: "M0 0l12.11 122.4h53L77.56 0zm6.16 16.11L5 4.29h67.68l-1.21 11.76z",
  fill: "currentColor",
  "data-name": "Layer 1"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 77.56 122.4"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/beer.svg";
export { SvgComponent as ReactComponent };